import dayjs from "dayjs";
import { useMemo } from "react";

/**
 * Stabilize Ant Design DatePicker `value` references.
 *
 * rc-picker resets the visible month to the selected value whenever the
 * `value` object identity changes while the panel is open. Formik helpers
 * often rebuild `dayjs(value)` on every render, which triggers that reset
 * and prevents selecting a date in another month.
 */
const useStableDatePickerValue = (value) => {
  const isControlled = value !== undefined;
  const valueTimestamp = dayjs.isDayjs(value)
    ? value.valueOf()
    : value
      ? dayjs(value).valueOf()
      : null;

  return useMemo(() => {
    if (valueTimestamp === null || Number.isNaN(valueTimestamp)) {
      return isControlled ? null : undefined;
    }
    return dayjs(valueTimestamp);
  }, [valueTimestamp, isControlled]);
};

export default useStableDatePickerValue;
